import "core-js/modules/es.array.push.js";
import LoadingDots from '@/dow-platform/components/commerce/shared/loading-dots/index.js';
import StatusBar from '../shared/status-bar.vue';
import DcSelectBox from '@/dow-platform/components/ui/forms/DcSelectBox.vue';
import PurchaseCartAlert from '../shared/purchase-cart-alert.vue';
import ServletHelper from '../../myAccount/helper/servlet-helper';
import DcModal from '@/dow-platform/components/ui/modal/DcModal.vue';
import ApiClient from '@/plugins/AxiosPlugin';
import { ChevronIcon } from '../../blocks/svg-elements/chevron-icon';
const paymentSteps = [{
  title: 'checkout.orderStatus.payment',
  status: true
}, {
  title: 'checkout.orderStatus.reviewAndPlaceOrder',
  status: false
}, {
  title: 'confirmation.Title',
  status: false
}];
export default {
  name: 'Credit Card Payment',
  components: {
    LoadingDots,
    StatusBar,
    DcSelectBox,
    PurchaseCartAlert,
    DcModal,
    ChevronIcon
  },
  emits: ['saveFailure'],
  data() {
    return {
      loading: false,
      saveLoading: false,
      paymentData: null,
      paymentSteps: paymentSteps,
      apiCallFailure: false,
      cardNumberToken: "",
      cardType: "",
      cardExpireMonthIndex: 0,
      cardExpireYearIndex: 0,
      cardExpireMonth: 0,
      cardExpireYear: 0,
      cardNumberError: false,
      expirationDateError: false,
      showSimulateErrorModal: false,
      simulateErrorMessages: [],
      isExpanded: false,
      expiryDateError: false,
      iframeKey: 0,
      hideDetails: false
    };
  },
  async created() {
    this.loading = true;
    await this.getPaymentData();
  },
  computed: {
    months() {
      return Array(13).fill(0).map((_, i) => {
        return {
          id: i,
          value: i,
          title: i != 0 ? ("0" + i).slice(-2) : ''
        };
      });
    },
    years() {
      return Array(12).fill(0).map((_, i) => {
        let date = new Date();
        return {
          id: i,
          value: i != 0 ? date.getFullYear() + i - 1 : 0,
          title: i != 0 ? date.getFullYear() + i - 1 : ''
        };
      });
    }
  },
  methods: {
    isMultiPO() {
      return this.paymentData?.isMultiPO;
    },
    totalsByPo() {
      return this.paymentData?.totalsByPo || [];
    },
    singlePo() {
      return this.paymentData?.totalsByPo?.[0].poNumber;
    },
    hasMultipleSubtotals() {
      return this.paymentData?.totalsByPo?.[0].totalsByPoList?.length > 1;
    },
    subTotals() {
      return this.paymentData?.totalsByPo?.[0].totalsByPoList?.map(total => total.totalsByCurrency?.subtotalAmountFormatted);
    },
    getCurrencies() {
      return this.paymentData?.totalsByPo?.[0].totalsByPoList?.map(total => total.currency);
    },
    isIndia() {
      return this.paymentData?.isIndia;
    },
    getLabel(key) {
      return window.Granite.I18n.get(key);
    },
    isExpirationInvalid() {
      let currentDate = new Date();
      return this.cardExpireMonth == 0 || this.cardExpireYear == 0 || this.cardExpireMonth < currentDate.getMonth() + 1 && this.cardExpireYear == currentDate.getFullYear();
    },
    isYearInvalid() {
      return this.cardExpireYear == 0;
    },
    isCardValid() {
      return this.cardNumberToken != null && this.cardNumberToken != "" && this.cardType != null && this.cardType != "";
    },
    handleMonthSelection(event) {
      this.cardExpireMonth = event.value;
      this.cardExpireMonthIndex = event.id;
      if (this.cardExpireYear) {
        this.expirationDateError = this.isExpirationInvalid();
      }
    },
    handleYearSelection(event) {
      this.cardExpireYear = event.value;
      this.cardExpireYearIndex = event.id;
      if (this.cardExpireMonth) {
        this.expirationDateError = this.isExpirationInvalid();
      }
    },
    setupListeners() {
      window.addEventListener("message", event => {
        if (event.origin === "https://stage.snappayglobal.com" || event.origin === "https://www.snappayglobal.com") {
          var token = event.data.split('&').filter(a => a.startsWith("token"))[0].split('=')[1];
          var brand = event.data.split('&').filter(a => a.startsWith("brand"))[0].split('=')[1];
          this.cardNumberError = token == null || token == "";
          this.expiryDateError = false;
          this.cardNumberToken = token;
          this.cardType = brand == 'DISCOVER' ? 'DISC' : brand;
        }
      });
      this.loading = false;
      this.hideDetails = false;
      if (this.showSimulateErrorModal) {
        this.toggleSimulateModal();
      }
    },
    async getPaymentData() {
      try {
        this.paymentData = await ServletHelper.makeServletCall(this.$store.state.settings.payment_servlet, '', {
          'Cache-Control': 'no-cache'
        });
        if (this.paymentData == null) {
          console.error('Error loading payment data.  Payment data missing.');
          this.apiCallFailure = true;
          return;
        }
        //decode and re-set src url
        let src = decodeURIComponent(this.paymentData?.paymentHostUrl);
        this.paymentData.paymentHostUrl = src;
        this.isExpanded = !this.isMultiPO || this.totalsByPo.length <= 5;
      } catch (error) {
        console.error('Error loading payment data:', error);
        //redirect
        if (error.response?.status === 302) {
          this.$router.push({
            name: 'cart'
          });
        } else {
          //show error alert for other errors
          this.apiCallFailure = true;
        }
      }
    },
    toggleIsExpanded() {
      this.isExpanded = !this.isExpanded;
    },
    async completePayment() {
      if (this.isExpirationInvalid() || !this.isCardValid()) {
        this.expirationDateError = this.isExpirationInvalid();
        this.cardNumberError = !this.isCardValid();
        return;
      }
      const inputData = {
        "cardNumber": this.cardNumberToken,
        "creditCardSelect": this.paymentData?.creditCardSelect,
        "cardType": this.cardType,
        "expiryMonth": this.cardExpireMonth,
        "expiryYear": this.cardExpireYear,
        "issueNumber": this.cardNumberToken
      };

      // Issue number is the same as card number
      const url = this.$store.state.settings.checkout_servlet;
      const data = new FormData();
      data.append('inputData', JSON.stringify(inputData));
      this.saveLoading = true;
      try {
        const res = await ApiClient.post(url, data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.saveLoading = false;
        const responseData = res.data;
        if (responseData?.errorMessages) {
          this.expiryDateError = responseData.errorMessages?.[0] === "expiryDateIssue";
          if (this.expiryDateError) {
            this.clearCreditCardDetails();
          } else {
            this.simulateErrorMessages = responseData.errorMessages;
            this.showSimulateErrorModal = true;
          }
        } else {
          this.$router.push({
            name: "checkout"
          });
        }
      } catch (error) {
        this.saveLoading = false;
        console.error('Saving payment details failed', error);
        this.$emit('saveFailure', true);
      }
    },
    toggleSimulateModal() {
      this.showSimulateErrorModal = !this.showSimulateErrorModal;
    },
    redirectToCart() {
      this.$router.push({
        name: "cart"
      });
    },
    clearCreditCardDetails() {
      this.hideDetails = true;
      this.getPaymentData().then(() => {
        this.iframeKey += 1;
        this.cardExpireMonthIndex = 0;
        this.cardExpireYearIndex = 0;
        this.cardExpireMonth = 0;
        this.cardExpireYear = 0;
        this.cardType = "";
        this.cardNumberToken = "";
      });
    }
  }
};